import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { message, Flex, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import Icon from '@ant-design/icons';
import { ReactComponent as cancel } from '../assets/icons/cancel.svg';
import './ErrorMessageContext.css';

const { Text } = Typography;
export const ErrorMessageContext = createContext();

export const ErrorMessageProvider = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();

  const addErrorMessage = (
    message,
    type = 'error',
    key = Date.now(),
    duration = 3,
    showCancel = false,
    keepVisible = false
  ) => {
    messageApi.open({
      key: key,
      type,
      content: (
        <Flex align="flex-start">
          {type !== 'loading' && (
            <InfoCircleOutlined
              style={{
                fontSize: '20px',
                marginRight: '12px',
                ...(type === 'notify' && {
                  color: 'var(--primary-text-color, #FFFFFF)',
                }),
              }}
            />
          )}
          <Text
            align="left"
            style={{
              color:
                type === 'notify'
                  ? 'var(--primary-text-color, #FFFFFF)'
                  : 'inherit',
            }}
          >
            {message}
          </Text>
          {showCancel && (
            <Icon
              component={cancel}
              onClick={() => {
                removeErrorMessage(key);
              }}
              style={{ marginLeft: '12px' }}
            />
          )}
        </Flex>
      ),
      duration:
        type !== 'loading' && type !== 'notify' && !keepVisible
          ? duration
          : undefined,
      icon: <></>,
      className:
        type === 'error'
          ? 'error-message'
          : type === 'success'
            ? 'success-message'
            : type === 'notify'
              ? 'info-notify'
              : 'info-message',
    });
  };

  const removeErrorMessage = key => {
    messageApi.destroy(key);
  };

  const contextValue = useMemo(
    () => ({ addErrorMessage, removeErrorMessage }),
    [addErrorMessage, removeErrorMessage]
  );

  return (
    <ErrorMessageContext.Provider value={contextValue}>
      {children}
      {contextHolder}
    </ErrorMessageContext.Provider>
  );
};

ErrorMessageProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
